import { render, staticRenderFns } from "./sender-form.vue?vue&type=template&id=e1b3092a&scoped=true"
import script from "./sender-form.vue?vue&type=script&lang=js"
export * from "./sender-form.vue?vue&type=script&lang=js"
import style0 from "./sender-form.vue?vue&type=style&index=0&id=e1b3092a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b3092a",
  null
  
)

export default component.exports